import React, { useContext, useEffect, useState } from 'react'
import TeamContext, { useTeam } from '../../data/team'
import { ReactComponent as PitchIcon } from '../../../../assets/icons/pitch.svg'
import { ReactComponent as BallIcon } from '../../../../assets/icons/ball.svg'
import dayjs from 'dayjs'
import styled from '@emotion/styled/macro'
import Loading from '../../../../components/Loading'
import Shield from '../../../../components/Shield'
import _AddressLinkComponent from '../../../../components/AddressLinkComponent'
import titleCase from 'lodash/startCase'
import EventAttendance from './EventAttendance'
import { Link, useNavigate } from 'react-router-dom'
import TeamCard from './TeamCard'
const FlexRow = styled('div')`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
`
const AddressLinkComponent = styled(_AddressLinkComponent)`
    background: var(--colors-grays-0);
    border: var(--borders-main);
    border-radius: var(--borderRadius-sm);
    padding: 0.5em;
    margin-top: 0.5rem;
    margin-left: 0;
`
const Section = styled('div')`
    background-color: var(--colors-grays-0);
    border: var(--borders-main);
    border-radius: var(--borderRadius-sm);
    padding: 0.5em 0.25em;
    margin-top: 0.5rem;
    margin-left: 0;
    transition: 0.4s ease all;
    ${({ hover }) =>
        hover &&
        `
   &:hover{
    background-color: var(--colors-primary-accent);
   } 
    `}
`

const TeamGrid = styled('div')`
    width: 100%;
    display: grid;
    grid-gap: 1.5rem;
    grid-template-columns: 1fr 1fr;
`
const UpcomingMatch = ({ event: nextMatch, activeTeam }) => {
    const {
        homeTeam = activeTeam?.nextMatch?.homeTeam,
        awayTeam = activeTeam?.nextMatch?.awayTeam,
    } = nextMatch.teams.reduce((acc, cv) => {
        if (cv.isHomeTeam) return { ...acc, homeTeam: cv }
        return { awayTeam: cv, ...acc }
    }, {})
    const navigate = useNavigate()
    return (
        <div>
            <TeamGrid>
                {homeTeam && (
                    <>
                        <TeamCard team={homeTeam?.team} />
                    </>
                )}
                {/* <BallIcon
                    height="1em"
                    width="1em"
                    style={{ flexShrink: 0 }}
                ></BallIcon> */}
                {awayTeam && <TeamCard team={awayTeam?.team}></TeamCard>}
            </TeamGrid>

            <AddressLinkComponent
                address={nextMatch?.address}
                title={homeTeam?.team?.pitch?.description}
            />
        </div>
    )
}

const NextEvent = ({
    eventId,
    noLink,
    event: _event,
    activeTeam: _activeTeam,
}) => {
    const [{ activeTeam = _activeTeam, isLoading }] = useTeam()
    const navigate = useNavigate()
    const event = _event || activeTeam?.eventStore?.[eventId]
    if (isLoading) return <Loading>loading...</Loading>
    if (!event) return <strong>no upcoming events</strong>
    const isMatch = ['leagueMatch', 'friendlyMatch'].includes(event.eventType)
    return (
        <>
            <h6
                style={{ margin: 0 }}
                onClick={() => !noLink && navigate('./events/' + event._id)}
            >
                {event.title ? event.title : titleCase(event.eventType)}{' '}
                {!noLink && '↗️ '}️
            </h6>
            <small style={{ marginBottom: '0.025rem' }}>
                {dayjs(event.startTime).format('DD/MM/YYYY HH:mm')}
            </small>
            {isMatch && (
                <UpcomingMatch
                    event={event}
                    activeTeam={activeTeam}
                ></UpcomingMatch>
            )}
            {!isMatch && (
                <AddressLinkComponent
                    address={event?.location}
                    title={event?.address}
                />
            )}
            {event.attendances && (
                <Section hover>
                    <EventAttendance event={event} view="button" />
                </Section>
            )}
        </>
    )
}
export default NextEvent
